import React, { useEffect, useRef, useState } from "react";
import { db } from "../../utils/firebase";
import { collection, doc, getDoc, getDocs } from "firebase/firestore";
import { ReactComponent as RightArrow } from "../../assets/icons/rightArrow.svg";
import { ReactComponent as Loading } from "../../assets/icons/loading.svg";
import { ReactComponent as Check } from "../../assets/icons/check.svg";
import SignupForm from "./signupForm";

const TutorSignup = ({ user }) => {
  const [userInputEmail, setUserInputEmail] = useState("");
  const [hasSubmittedApplication, setHasSubmittedApplication] = useState(false);
  const [hasBeenApproved, setHasBeenApproved] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [email, setEmail] = useState("");
  const errorMsg = useRef();
  const approvalForm = useRef();
  const [approvalRefID, setApprovalRefID] = useState(null);

  const thisUserHasBeenApproved = async () => {
    setProcessing(true);
    let approved = false;
    const querySnapshot = await getDocs(collection(db, "approvedApplicants"));
    querySnapshot.forEach((doc) => {
      if (doc.data().email === userInputEmail) {
        setApprovalRefID(doc.id);
        setHasBeenApproved(true);
        setEmail(doc.data().email);
        approved = true;
        errorMsg.current.style.transform = "scale(0)";
        return;
      }
    });

    if (!approved) {
      errorMsg.current.style.transform = "scale(1)";
    }
  };

  useEffect(() => {
    if (hasBeenApproved) {
      approvalForm.current.style.display = "hidden";
    }
  }, [hasBeenApproved]);

  return (
    <div>
      <div
        className="flex justify-center items-center flex-col px-10 mt-[10em]"
        ref={approvalForm}
      >
        <p className="text-[1.4em] md:text-[1.8em] font-medium text-gray-700 mb-20">
          {hasSubmittedApplication
            ? "Enter the email you used for your application"
            : "Have you submitted your application?"}
        </p>
        <div className="flex flex-col gap-10">
          <div
            className={`flex items-center justify-between flex-wrap bg-white p-5 shadow-md rounded-[50px] border-[1px] ${
              hasSubmittedApplication && "hidden"
            }`}
          >
            <p className="text-[1.1em] font-medium md:text-[1.2em] text-gray-800 mr-5">
              Yes
            </p>
            <button
              className="bg-black p-3 rounded-[50px] transition duration-300 ease-in-out hover:translate-x-1"
              onClick={() => {
                setHasSubmittedApplication(true);
              }}
            >
              <RightArrow color="white" />
            </button>
          </div>
          {hasSubmittedApplication && (
            <div className="">
              <form
                className="flex items-center justify-center gap-5"
                onSubmit={async (e) => {
                  e.preventDefault();
                  if (!hasBeenApproved) {
                    await thisUserHasBeenApproved();
                    setProcessing(false);
                  }
                }}
              >
                <div
                  className={`rounded-full py-3 pl-2 border-[2px] bg-white relative transition duration-200 ease-in-out ${
                    !userInputEmail ? "translate-x-7" : "translate-x-0"
                  } `}
                >
                  <p
                    className={`bg-white mx-2 px-1 pointer-events-none absolute translate-x-4 text-gray-700 font-medium transition duration-200 ease-in-out hover ${
                      userInputEmail
                        ? "translate-x-0 -translate-y-6 bg-white "
                        : "translate-x-2"
                    }`}
                  >
                    Email
                  </p>
                  <input
                    type="email"
                    className="flex-1 bg-transparent pl-3 outline-none text-gray-800 text-[1.1em] font-medium"
                    value={userInputEmail}
                    onChange={(e) => setUserInputEmail(e.target.value)}
                  />
                </div>
                <button
                  type="submit"
                  className={`${
                    hasBeenApproved ? "bg-green-500" : "bg-black"
                  } p-3 rounded-[50px] transition duration-300 ease-in-out scale-0 ${
                    userInputEmail && "scale-[1]"
                  }`}
                >
                  {processing ? (
                    <Loading className="animate-spin" color="white" />
                  ) : hasBeenApproved ? (
                    <Check />
                  ) : (
                    <RightArrow color="white" />
                  )}
                </button>
              </form>
              <p
                className="mt-10 scale-[0] transition duration-200 ease-in-out text-red-600"
                ref={errorMsg}
              >
                If you've submitted your application, it's likely that your
                application is still under review. Please contact your
                recruiter.
              </p>
            </div>
          )}

          <div
            className={`flex items-center justify-between flex-wrap bg-white p-5 shadow-md rounded-[50px] border-[1px] ${
              hasSubmittedApplication && "hidden"
            }`}
          >
            <p className="text-[1.1em] font-medium md:text-[1.2em] text-gray-800 mr-5">
              No
            </p>
            <button className="bg-black p-3 rounded-[50px] transition duration-300 ease-in-out hover:translate-x-1">
              <a
                href="https://www.google.com/search?q=Am I smart enough to be a tutor? lmao"
                target="_blank"
                rel="noreferrer"
              >
                <RightArrow color="white" />
              </a>
            </button>
          </div>
        </div>
      </div>
      <div className="flex justify-center w-screen items-center">
        <SignupForm
          //TODO: Change back
          hasBeenApproved={hasBeenApproved}
          email={email}
          user={user}
          approvalRefID={approvalRefID}
        />
      </div>
    </div>
  );
};

export default TutorSignup;
